export const setProfileMapData = (state, action) => {
  state.countDetails = action.payload;
};

export const setCompanyCategory = (state, action) => {
  state.companyCategory = action.payload;
};

export const setTabDetails = (state, action) => {
  state.tabDetails = action.payload;
};

export const setParentStatusHandler = (state, action) => {
  state.isParentSubs = action.payload;
};

export const setCompanyProfileTypeHandler = (state, action) => {
  state.companyProfileType = action.payload;
};

export const setBuyerCachingHandler = (state, action) => {
  state.buyerCaching = action.payload;
};

export const setSupplierCachingHandler = (state, action) => {
  state.supplierCaching = action.payload;
};

export const setLogisticsCachingHandler = (state, action) => {
  state.logisticsCaching = action.payload;
};

export const setCorporateHierarchyCachingHandler = (state, action) => {
  state.corporateHierarchyCaching = action.payload;
};
